import { ArticleHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CellGroup.css';

interface ICellGroupProps {
  title?: string;
}

export const CellGroup: React.FC<React.PropsWithChildren<ICellGroupProps>> = ({ title, children }) => {
  return (
    <div role="group" className={styles['container']}>
      {title && (
        <div className={styles['title']}>
          <ArticleHeading3 as="div">{title}</ArticleHeading3>
        </div>
      )}
      <div className={styles['content']}>
        <ul className={styles['list']}>{children}</ul>
      </div>
    </div>
  );
};
